var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppFeature2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 25.5V12H33",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 12L30.622 27.878C30.3434 28.1568 30.0126 28.3779 29.6485 28.5288C29.2844 28.6797 28.8941 28.7574 28.5 28.7574C28.1059 28.7574 27.7156 28.6797 27.3515 28.5288C26.9874 28.3779 26.6566 28.1568 26.378 27.878L20.122 21.622C19.8434 21.3432 19.5126 21.1221 19.1485 20.9712C18.7844 20.8203 18.3941 20.7426 18 20.7426C17.6059 20.7426 17.2156 20.8203 16.8515 20.9712C16.4874 21.1221 16.1566 21.3432 15.878 21.622L1.5 36",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgAppFeature2;